import React, { useState, useEffect } from 'react'
import { useTranslation } from '../../../../hooks/useTranslation'
import { Button } from '~/components/_atoms'

/**
 * DegradedModeNotification component - shows when media service falls back to text chat
 */
const DegradedModeNotification = ({ message, onDismiss }) => {
  const { t } = useTranslation('coach_chat')
  const [isVisible, setIsVisible] = useState(true)

  // Auto-dismiss after 8 seconds
  useEffect(() => {
    const timer = setTimeout(() => {
      setIsVisible(false)
      if (onDismiss) {
        onDismiss()
      }
    }, 8000)

    return () => clearTimeout(timer)
  }, [onDismiss])

  const handleDismiss = () => {
    setIsVisible(false)
    if (onDismiss) {
      onDismiss()
    }
  }

  if (!isVisible) {
    return null
  }

  return (
    <div className="fixed left-1/2 top-4 z-50 w-full max-w-md -translate-x-1/2 transform">
      <div className="mx-4 rounded-lg border border-blue-200 bg-blue-50 p-4 shadow-lg">
        <div className="flex items-start">
          <div className="flex-shrink-0">
            <svg
              className="h-5 w-5 text-blue-400"
              viewBox="0 0 20 20"
              fill="currentColor"
            >
              <path
                fillRule="evenodd"
                d="M18 10a8 8 0 11-16 0 8 8 0 0116 0zm-7-4a1 1 0 11-2 0 1 1 0 012 0zM9 9a1 1 0 000 2v3a1 1 0 001 1h1a1 1 0 100-2v-3a1 1 0 00-1-1H9z"
                clipRule="evenodd"
              />
            </svg>
          </div>
          <div className="ml-3 flex-1">
            <h3 className="text-sm font-medium text-blue-800">
              {t('degraded_mode.title', {
                defaultValue: 'Media Chat Unavailable',
              })}
            </h3>
            <p className="mt-1 text-sm text-blue-700">{message}</p>
          </div>
          <div className="ml-4 flex-shrink-0">
            <Button
              variant="ghost"
              size="sm"
              onClick={handleDismiss}
              className="text-blue-400 hover:text-blue-600"
              aria-label={t('degraded_mode.dismiss', {
                defaultValue: 'Dismiss',
              })}
            >
              <svg
                className="h-4 w-4"
                fill="none"
                viewBox="0 0 24 24"
                stroke="currentColor"
              >
                <path
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  strokeWidth={2}
                  d="M6 18L18 6M6 6l12 12"
                />
              </svg>
            </Button>
          </div>
        </div>
      </div>
    </div>
  )
}

export default DegradedModeNotification
